import { useGet } from "../utils/apiComponent/useApi"
import { endpoints } from "../utils/endpoints"

/**
 * Hook pour récupérer tous les certificats de l'utilisateur
 * GET /certificates/my-certificates
 */
export function useCertificates() {
  const {
    data,
    loading,
    error,
    execute
  } = useGet(endpoints.myCertificates)

  // L'API retourne { success, data, messages, errors }
  const certificates = data?.data || data || []

  return {
    certificates,
    loading,
    error,
    refetch: execute
  }
}

